export default "__VITE_ASSET__4ff13c5d__"